import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  pendentes: [],
  colunas: [
    {
      value: 'referenciaCliente',
      i18n: 'referenciaCliente',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'referenciaTrust',
      i18n: 'referenciaTrust',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'dataAbertura',
      i18n: 'dataAbertura',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'eta',
      i18n: 'eta',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'nomePessoa',
      i18n: 'cliente',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'responsavel',
      i18n: 'responsavel',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'dataEmbarque',
      i18n: 'dataEmbarque',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'possuiInvoice',
      i18n: 'invoice',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'possuiConhecimento',
      i18n: 'bl',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'possuiContainer',
      i18n: 'container',
      text: '',
      sortable: false,
      filterable: false,
      ativo: false,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
  ],
  filtros: {},
  campos: {
    dataAbertura: 'dataAbertura',
    eta: 'eta',
    nomePessoa: 'nomePessoa',
    responsavel: 'responsavel',
    dataEmbarque: 'dataEmbarque',
    possuiConhecimento: 'possuiConhecimento',
    possuiContainer: 'possuiContainer',
    possuiInvoice: 'possuiInvoice',
    referenciaCliente: 'referenciaCliente',
    referenciaTrust: 'referenciaTrust',
  },
};
